import { useEffect, useRef } from "react";
import ScrollMorphHero from "@/components/ui/scroll-morph-hero";
import GlobalHeader from "@/components/GlobalHeader";
import Footer from "@/components/Footer";
import { usePageSEO } from "@/hooks/use-page-seo";

const LifestyleV2 = () => {
  usePageSEO({
    title: "Yacht Rock Detroit | Music, Culture & Detroit Waterfront Life",
    description: "Explore the world of Yacht Rock Detroit — articles on the genre, the artists, the Detroit waterfront scene, and everything that makes July 17–18, 2026 worth marking on your calendar.",
    keywords: "yacht rock Detroit, yacht rock culture, Detroit waterfront events, smooth rock music, yacht rock festival 2026, Detroit summer music",
    breadcrumbs: [
      { name: "Home", url: "https://yachtrockdetroit.com/" },
      { name: "Lifestyle", url: "https://yachtrockdetroit.com/lifestyle" },
    ],
  });
  const heroRef = useRef<HTMLElement>(null);
  
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <main className="min-h-screen bg-yacht-blue">
      <GlobalHeader heroRef={heroRef} />
      <section ref={heroRef}>
        <ScrollMorphHero
          title="Yacht rock is more than a genre."
          subtitle="SCROLL TO EXPLORE"
          activeTitle="It's a Lifestyle"
          activeDescription="Discover the smooth sounds, sunset vibes, and unforgettable moments that define the yacht rock experience."
        />
      </section>
      <Footer />
    </main>
  );
};

export default LifestyleV2;
